const PROGRAMS = {
  RWANDA_RMS: 'program:rwanda-rms'
}

const FUNDERS = {
  RWANDA_RMS: 'funder:rwanda-rms'
}

module.exports = {
  PROGRAMS,
  FUNDERS
}
